<template>
  <BaseSelectField
    v-bind="$props"
    :model-value="modelValue"
    @change="$emit('change', $event)"
    @update:modelValue="$emit('update:modelValue', $event)"
    @selectClick="$emit('selectClick')"
    @selectOpen="$emit('selectOpen')"
  />
</template>

<script>
import BaseSelectField from './BaseSelectField.vue';
import commonProps from './common-props-mixin';
import validation from './validation-mixin';

export default {
  name: 'SelectField',
  emits: ['change', 'update:modelValue', 'selectClick', 'selectOpen'],
  mixins: [validation, commonProps],
  components: { BaseSelectField },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    modelValue: {
      type: [String, Number],
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
